var vms = vms || {};

vms.topMenu = {
    profile: null,
    profileSearchMin: 2,
    msg: null,
    notify: null,
    title: {"P":"Profile"},
    loading: "Loading...",
    opened: "",
    fetchInProgress: false,
    outsideClickListener: (event) => {
        var selector = ".vmsTop_" + vms.topMenu.opened;
        $target = $(event.target);
        if (!$target.closest(selector).length && $(selector).is(':visible')) {
            vms.topMenu.removeClickListener();
        }
    },
    removeClickListener: () => {
        document.removeEventListener('click', vms.topMenu.outsideClickListener);
        var $menu = $(".vmsTop_"+ vms.topMenu.opened);
        $menu.find(".t-Button").removeClass("is-active");
        $menu.find(".vmsTop").hide();
        vms.topMenu.opened = "";
    },
    refresh: (pMenu) => {
        var $menu = $(".vmsTop_"+ pMenu);
        var $menuDiv = $menu.find(".vmsTop");
        if ($menuDiv.length > 0) {
            $menuDiv.remove();
        }
        setTimeout( () => vms.topMenu.open(pMenu), 1000);
    },
    open: function (pMenu, pFromFetch){
        var menu = pMenu;
        var $menu = $(".vmsTop_"+ menu);
        var $menuDiv = $menu.find(".vmsTop");

        if (vms.topMenu.fetchInProgress) {
            return;
        } else if (menu != vms.topMenu.opened){
            vms.topMenu.removeClickListener();
        }

        if ($menuDiv.is(":visible")) {
            vms.topMenu.removeClickListener();
            return;
        } else if ($menuDiv.length > 0) {
            vms.topMenu.opened = menu;
            $menuDiv.show();
        } else if (pFromFetch){
            var lTopMenu = "";
            var lBtns;
            switch (menu) {
                case 'P':   lTopMenu = vms.topMenu.genProfile();
                            lBtns = vms.topMenu.profile.btn; break;
                default: return;
            }
            // generate buttons
            var lBtnsHTML = "";
            if (lBtns) {
                for (let j = 0; j < lBtns.length; j++) {
                    lBtnsHTML += vms.btn.gen( lBtns[j] );
                }
                lBtnsHTML = '<div class="btnContainer">'+ lBtnsHTML +'</div>';
            }
            // form complete dropdown html
            lTopMenu = '<div class="vmsTop"><div class="hdr"><h1>'+ vms.topMenu.title[menu] +'</h1>'+ lBtnsHTML +'</div><div class="content">'+ lTopMenu +'</div></div>';
            $menu.append(lTopMenu);
            vms.topMenu.opened = menu;
        } else {
            vms.topMenu.getData(menu);
            return;
        }

        $menu.find(".t-Button--navBar").addClass("is-active");
        document.addEventListener('click', vms.topMenu.outsideClickListener);
    
        if ($(document).width() > 640){
            if (menu == 'P' && vms.topMenu.profile.rows.length >= vms.topMenu.profileSearchMin) setTimeout(function(){ $("#topMenuProfileTerm").focus(); }, 100);
        }
    },
    getData: function (pMenu, pRow) {
        vms.topMenu.fetchInProgress = true;
        apex.server.process("getTopMenuJson", {
            x01: pMenu,
            x02: (pRow ? pRow : 0)
        },{
            dataType: 'json',
            success: function (d) {
                vms.topMenu.fetchInProgress = false;
                if (pRow){
                    vms.topMenu.append(pMenu, d);
                } else {
                    switch (pMenu) {
                        case "P":
                            vms.topMenu.profile = d;
                            vms.topMenu.title.P = d.loc.title;//d.currentName;
                            break;
                        default:
                            break;
                    }
                    vms.topMenu.open(pMenu, true);
                }
            },
            error: function( jqXHR, textStatus, errorThrown ) {
                vms.topMenu.fetchInProgress = false;
                console.log( errorThrown );
            }
        });
    },
    genProfile: function (){
        var lRet = "";
        for (var i = 0; i < vms.topMenu.profile.rows.length; i++) {
            var row = vms.topMenu.profile.rows[i];
            lRet += '<div class="group">'+
                    '<div class="box box'+ row.type + (vms.topMenu.profile.current == row.id ? ' current' : 
                                            (row.switch ? '" onclick="vms.nav.switch('+ row.id +');" title="'+ vms.topMenu.profile.loc.switch : ' noSwitch') ) +'">'+
                        '<div class="content">'+
                            '<div class="fv fv-profile-'+ row.type +'"></div>'+
                            '<div class="txt">'+
                                '<p class="name">'+ vms.util.escapeHTML(row.name) +'</p>'+
                                (row.label ? '<p>'+ row.label +'</p>' : '')+
                            '</div>'+
                        '</div>'+
                    '</div>';
            // Vessels
            if (row.vsl) {
                for (var j = 0; j < row.vsl.length; j++) {
                    var vsl = row.vsl[j];
                    lRet += '<div class="box'+ (vms.topMenu.profile.current == vsl.id ? ' current' : 
                                                (vsl.switch ? '" onclick="vms.nav.switch('+ vsl.id +');" title="'+ vms.topMenu.profile.loc.switch : ' noSwitch') ) +'">'+
                                '<div class="content">'+
                                    '<div class="fv fv-profile-VSL"></div>'+
                                    '<div class="txt">'+
                                        '<p class="name">'+ vms.util.escapeHTML(vsl.name) +'</p>'+
                                        (vsl.label ? '<p>'+ vsl.label +'</p>' : '')+
                                    '</div>'+
                                '</div>'+
                            '</div>';
                }
            }
            lRet += '</div>'
        }
        if (vms.topMenu.profile.rows.length >= vms.topMenu.profileSearchMin){
            return '<div class="topMenuSearch"><input id="topMenuProfileTerm" type="text" class="text_field apex-item-text" value=""'+
                        ' placeholder="Please enter at least 3 characters"'+
                        ' onkeydown="vms.topMenu.searchProfile(event);" /></div>'+
                    '<div class="topMenuResults" id="topMenuProfileResults">'+ lRet +'</div>';
        } else return lRet;
    },
    searchProfile: (e) => {
        //console.log(e);
        if (e.keyCode == 13){
            e.preventDefault();
            $("#topMenuProfileResults .box:visible:first").trigger( "click" );
            return false;
        };
        var term = e.target.value.toLowerCase();
        if (term.length = "")
            $("#topMenuProfileResults .box").show();
        else
            $("#topMenuProfileResults .box").each( function () {
                var $box = $(this);
                var name = $box.find(".name").text().toLowerCase();
                if (name.includes(term)) $box.show();
                else $box.hide();
            });
    }
};